import { Checkbox, DataSource, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutARAgingReport extends Layout {
    checkboxOpenCredits: Checkbox;
    checkboxPastDue: Checkbox;
    sourceArAgingReport: DataSource;
    textboxAgeDate: Textbox;
    textboxInvoiceCutoff: Textbox;
    textboxPaymentCutoff: Textbox;
    textboxReportBy: Textbox;
    textboxReportType: Textbox;
}
